const compose = (formMap) => (values, props) => Object.entries(formMap).reduce((errors, [key, validate]) => ({
    ...errors,
    [key]: validate(values, props),
}), {});

export default compose;
